import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../redux/actions/actions';
import { useNavigate } from 'react-router-dom';
import BlogList from '../components/BlogList';
import Axios from '../utils/axiosInstance';
import Myorders from '../components/Myorders'
import AddressList from '../components/AddressList';

const MyAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("dashboard");
  const auth = useSelector((state) => state.auth);
const user = auth.user
const handleLogout = async () => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}api/logout/`;
    await Axios.post(apiUrl, { refresh_token: auth.token.refresh });
  } catch (error) {
    // Silently catch the error without showing it
  } finally {
    // Always dispatch logout and navigate to login page
    dispatch(logout());
    navigate("/login");
  }
};


  
  return (
    <div className="max-w-7xl w-full max-w-[900px] mx-auto py-8">
      {/* Title */}
      <h1 className="text-3xl font-bold mb-6 text-center">MY ACCOUNT</h1>

      {/* Main content wrapper */}
      <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-8 lg:space-x-8">
        {/* Sidebar */}
        <aside className="w-full md:w-1/4 bg-gray-100 p-4 rounded-md">
          <ul className="space-y-4">
            <li className="flex items-center space-x-2">
              <i className="fa-solid fa-chess-board"></i>
              <button
                onClick={() => setActiveSection("dashboard")}
                className={`hover:underline ${
                  activeSection === "dashboard" ? "text-blue-600" : ""
                }`}
              >
                Dashboard
              </button>
            </li>
            <li className="flex items-center space-x-2">
              <i className="fa-solid fa-location-crosshairs"></i>
              <button
                onClick={() => setActiveSection("addresses")}
                className={`hover:underline ${
                  activeSection === "addresses" ? "text-blue-600" : ""
                }`}
              >
                Addresses 
              </button>
            </li>
            <li className="flex items-center space-x-2">
              <i className="fa-solid fa-list"></i>
              <button
                onClick={() => setActiveSection("orders")}
                className={`hover:underline ${
                  activeSection === "orders" ? "text-blue-600" : ""
                }`}
              >
                My Orders
              </button>
              </li>
            <li className="flex items-center space-x-2">
              <i className="fa-solid fa-blog"></i>
              <button
                onClick={() => setActiveSection("blogs")}
                className={`hover:underline ${
                  activeSection === "blogs" ? "text-blue-600" : ""
                }`}
              >
                My Blogs
              </button>
            </li>
            <li className="flex items-center space-x-2">
              <i className="fa-solid fa-right-from-bracket"></i>
              <button onClick={handleLogout} className="hover:underline">
                Logout
              </button>
            </li>
          </ul>
        </aside>

        {/* Main content */}
        <div className="flex-1">
          {activeSection === "dashboard" && (
            <div>
              {/* Dashboard Section */}
              <div className="flex items-center text-xl font-semibold">
                <i className="fa-solid fa-user-circle text-blue-500 mr-2 text-2xl"></i>
                <span>
                  Hello,{" "}
                  <span className="font-bold mx-2 text-blue-600">
                    {user?.name}
                  </span>
                  <span className="font-bold mx-2 text-xs text-black-600">
                    (not {user?.name}? )
                    <i onClick={handleLogout} className="fa-solid fa-sign-out text-red-500 mr-2 text-2xl ml-5 cursor-pointer"></i>
                    <span className='text-red-500 cursor-pointer' onClick={handleLogout}>
                      LOGOUT
                    </span>
                  </span>
                 
                </span>
              </div>

              {/* <div className="mt-6">
                <h2 className="text-lg font-semibold">Order History:</h2>
                <button className="mt-2 px-4 py-2 bg-gray-800 text-white font-semibold rounded-md">
                  Exchange Status
                </button>
                <p className="mt-2 text-green-600">
                  ✔{" "}
                  <a href="/" className="underline">
                    Make your first order
                  </a>{" "}
                  You haven't placed any orders yet.
                </p>
              </div> */}
            </div>
          )}

          {activeSection === "addresses" && (
            <div>
              {/* Addresses Section */}
              {/* <h2 className="text-lg font-semibold mb-4">My Addresses:</h2> */}
              <AddressList />
            </div>
          )}

          {activeSection === "blogs" && (
            <div>
              <BlogList user_id={user.id} />
            </div>
          )}
           {activeSection === "orders" && (
            <div>
             <h2 className="text-lg font-semibold mb-4">My Orders</h2>
             <Myorders />
            </div>
          )}

          {/* Account Details */}
          {activeSection === "dashboard" && (
            <div className="mt-8">
              <h2 className="text-lg font-semibold mb-4">Account Details:</h2>
              <table className="min-w-full mt-6 border border-gray-300">
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-semibold border-r">Name:</td>
                    <td className="py-2 px-4 text-xs">{user?.name}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-semibold border-r">E-mail:</td>
                    <td className="py-2 px-4 text-xs">{user?.email}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4 font-semibold border-r">
                      Address:
                    </td>
                    <td className="py-2 px-4 text-xs">{user?.address}</td>
                  </tr>
                  <tr>
                    <td className="py-2 px-4 font-semibold border-r">
                      Address 2:
                    </td>
                    <td className="py-2 px-4 text-xs">{user?.address2}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
